export const NEW_DOCUMENT_RELOAD_CONFIRM_MESSAGE =
  "Warning: all data will be deleted upon confirmation. Are you sure you want to create a new document?";

export const confirmNewDocumentReload = (): boolean => window.confirm(NEW_DOCUMENT_RELOAD_CONFIRM_MESSAGE);

export const reloadPageAfterNewDocumentConfirm = (): void => {
  if (confirmNewDocumentReload()) {
    window.location.reload();
  }
};
